let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bzwfz")).then(() => parcelRequire('7JV09'));